import React from "react";

const IntroBlock = () => (
  <div className="tv-block tv-intro">
    <h5 className="tv-block-title">Trip Verification</h5>
    <p className="tv-block-body mb-0">
      Please confirm all records and make any necessary edits. Ensure all
      relevant Trip Notes are logged.
    </p>
  </div>
);

export default IntroBlock;
